import { LocalizedEnumApiModel } from './localized-enum-api.model';

export class LocalizedEnum {
    enumValue: string;
    displayString?: string;

    constructor(apiModel?: LocalizedEnumApiModel) {
        if (apiModel) {
            this.enumValue = apiModel.enumValue;
            this.displayString = apiModel.displayString;
        }
    }
}
